import { render, staticRenderFns } from "./paramsForm.vue?vue&type=template&id=639a3add&scoped=true&"
import script from "./paramsForm.vue?vue&type=script&lang=js&"
export * from "./paramsForm.vue?vue&type=script&lang=js&"
import style0 from "./paramsForm.vue?vue&type=style&index=0&id=639a3add&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a3add",
  null
  
)

export default component.exports